import React from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

export const ReCaptchaProvider = ({ children, reCaptchaKey }) => (
  <GoogleReCaptchaProvider reCaptchaKey={reCaptchaKey}>
    {children}
  </GoogleReCaptchaProvider>
);
